import { type TFunction } from "i18next";
import { z } from "zod";
import {
  validateAttachmentDocuments,
  validateNumberOfSkips,
  validateQuantity,
  validateUnit,
} from "./sharedValidators";

const LANG_BASE = "vessel-call.port-services";

type DocumentData = {
  url: string;
  type?: string;
  certificateType?: string;
  name?: string;
  originalFileName?: string;
  expirationDate?: Date | string | null;
};

type WasteDisposalData = {
  serviceCategory?: string;
  serviceType?: string;
  serviceSubType?: string;
  quantity?: string;
  unitOfMeasurement?: string;
  numberOfSkips?: string;
  garbageCategory?: string;
  serviceLocation?: string;
  typeOfSludge?: string;
  attachmentDocuments?: DocumentData[];
  garbageDocument?: DocumentData[];
  slopsDocument?: DocumentData[];
  sludgeDocument?: DocumentData[];
};

export const validateWasteDisposalServices = (
  data: WasteDisposalData,
  ctx: z.RefinementCtx,
  t: TFunction,
) => {
  //condition should be removed when Sanitation service is implemented
  if (data.serviceSubType !== "Sanitation") validateAttachmentDocuments(data, ctx, t);

  if (data.serviceType === "Garbage") {
    validateNumberOfSkips(data.numberOfSkips, ctx, t);
    validateQuantity(data.quantity, ctx, t);
    validateUnit(data.unitOfMeasurement, ctx, t);
    const garbageCategory = data.garbageCategory;
    if (garbageCategory === undefined || garbageCategory === null || garbageCategory === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: t("form-validation.required", {
          label: t(`${LANG_BASE}.fields.garbage-category`),
        }),
        path: ["garbageCategory"],
      });
    }

    const serviceLocation = data.serviceLocation;
    if (serviceLocation === undefined || serviceLocation === null || serviceLocation === "") {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: t("form-validation.required", {
          label: t(`${LANG_BASE}.fields.service-location`),
        }),
        path: ["serviceLocation"],
      });
    }
  }
};
